module.exports = __webpack_public_path__ + "img/session-thematique-3-CaliforniaRoutine.94ab26c.jpg";